import {
    FETCH_WEEKLY_RECOGNITION,
    FETCH_WEEKLY_RECOGNITION_SUCCESS,
    FETCH_WEEKLY_RECOGNITION_FAILED,
    SAVE_WEEKLY_RECOGNITION,
    SAVE_WEEKLY_RECOGNITION_SUCCESS,
    SAVE_WEEKLY_RECOGNITION_FAILED,
} from '../actions/weeklyRecognitionActions';

const initialState = {
    loading: false,
    data: null,
    error: null,
};

export const weeklyRecognitionReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_WEEKLY_RECOGNITION:
        case SAVE_WEEKLY_RECOGNITION:
            return { ...state, loading: true, error: null };
        case FETCH_WEEKLY_RECOGNITION_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case SAVE_WEEKLY_RECOGNITION_SUCCESS:
            return { ...state, loading: false };
        case FETCH_WEEKLY_RECOGNITION_FAILED:
        case SAVE_WEEKLY_RECOGNITION_FAILED:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};
